import PageTitle from '../../components/CommonComps/Titles/PageTitle';
import PostalCodeModalsContainer from '../../components/SetupSubPageComps/PostalCodesComps/PostalCodeModalsContainer';
import ShowAllPostalCodes from '../../components/SetupSubPageComps/PostalCodesComps/ShowAllPostalCodes';
import PostalCodeProvider from '../../contexts/PostalCodeProvider';

const PostalCodes = () => {
  // rendering postal codes page component here
  return (
    <>
      <PageTitle title='Postal Codes' />

      <PostalCodeProvider>
        <ShowAllPostalCodes />
        <PostalCodeModalsContainer />
      </PostalCodeProvider>
    </>
  );
};

export default PostalCodes;
